var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showConfetti)?_c('lottie-player',{staticClass:"confetti-animation",attrs:{"src":JSON.stringify(require('@/assets/animations/ConfettiSavings.json')),"preserveAspectRatio":'xMidYMax',"autoplay":true,"loop":false}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }